// --------------------------------------------------
// Hamburger
// --------------------------------------------------

let hamburger = document.querySelector('[data-hamburger]');

if (hamburger) {
    hamburger.addEventListener('click', e => {
        e.preventDefault();
        hamburger.classList.toggle('is-active');
        document.documentElement.classList.toggle('navigation-open');
    });
}

// --------------------------------------------------
// Sub Nav
// --------------------------------------------------

$('.s-mobile-header .s-navigation__item--has-children > a').on('click', function() {
    const $this = $(this);
    const $parent = $this.parent();
    const $subMenu = $parent.find('.s-sub-navigation');

    $parent.toggleClass('s-navigation__item--is-open');
    $subMenu.slideToggle(300);

    return false;
});

// --------------------------------------------------
// Sub Sub Nav
// --------------------------------------------------

$('.s-mobile-header  .s-sub-navigation__item--has-children > a').on('click', function() {
    const $this = $(this);
    const $parent = $this.parent();
    const $subMenu = $parent.find('.s-sub-sub-navigation');

    $parent.toggleClass('s-sub-navigation__item--is-open');
    $subMenu.slideToggle(300);

    return false;
});



// WEBPACK FOOTER //
// ./src/js/components/mobile-navigation.js